var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_vm._t("default",null,null,slotProps)]}}],null,true)},'ValidationProvider',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }